import React, { memo } from "react";
import { colors, css, frames, useMediaQuery } from "../../Styles";

interface GridLayoutLfOverview_Props {
  CardDisplayComponent?: JSX.Element;
  SystemControlsComponent?: JSX.Element;
  AttentionsComponent?: JSX.Element;
  WidgetComponents?: JSX.Element;
}

const GridLayoutLfOverview = memo(({ CardDisplayComponent, SystemControlsComponent, AttentionsComponent, WidgetComponents }: GridLayoutLfOverview_Props) => {
   
  // Mediaquries
  const hideCardNumberDisplays = useMediaQuery(`(max-height: 765px)`);

  const gridMaxOut = useMediaQuery(`(min-width: 1845px)`); // Desktop 3 columns
  const gridReducerPrimary = useMediaQuery(`(max-width: 1290px)`); // Desktop 2 columns / Laptop
  const gridReducerSecondary = useMediaQuery(`(max-width: 720px)`); // Laptop
  const gridReducerTertiary = useMediaQuery(`(max-width: 590px)`); // Mobile
  
  if (gridReducerSecondary || gridReducerTertiary) {
    return (
      <frames._page_inner_content_scroll>
        <div style={{ display: "grid", gridTemplateColumns: gridReducerTertiary ? "1fr" : "320px 1fr", gridTemplateRows: gridReducerTertiary ? "1fr" : "150px 360px 1fr", height: "100%", gridGap: "20px", boxSizing: "border-box" }}>
          {gridReducerTertiary && (
            <div style={{ gridArea: "1/1/2/2", alignItems: "center", ...css.systemOverviewGrid_container1 }}>
              {CardDisplayComponent}
              {SystemControlsComponent}
              {AttentionsComponent}
              <div style={{ ...css.systemOverviewGrid_container2 }}>
                {WidgetComponents}
              </div>
            </div>
          )}

          {!gridReducerTertiary && ( <>
            <div style={{ gridArea: "1/1/2/2" }}>{CardDisplayComponent}</div>
            <div style={{ gridArea: "2/1/3/2" }}>{SystemControlsComponent}</div>
            <div style={{ gridArea: "1/2/3/3", overflow: "hidden" }}>{AttentionsComponent}</div>
            <div style={{ gridArea: "3/1/4/3", display: "flex", justifyContent: "center" }}>
              <div style={{ ...css.systemOverviewGrid_container2 }}>
                {WidgetComponents}
              </div>
            </div>
          </> )}
        </div>
        {/* <div style={{height: "150px", width: "100%"}}/> */}
      </frames._page_inner_content_scroll>
    );
  } else {
    return ( // Normal / Desktop
      <frames._page_inner_content>
        <div style={{ display: "grid", gridTemplateColumns: gridReducerPrimary ? "300px 1fr" : gridMaxOut ? "320px 1fr 380px" : "320px 1fr 210px", gridTemplateRows: gridReducerPrimary ? "1fr" : "1fr 350px", height: "100%", gridGap: gridReducerPrimary ? "0px 10px" : "10px 20px", boxSizing: "border-box" }}>
          {gridReducerPrimary && (
            <div style={{ gridArea: "1/1/2/2", padding: "0px 5px 150px 0px", paddingRight: "5px", ...css.systemOverviewGrid_container1 }}>
              {CardDisplayComponent}
              {SystemControlsComponent}
              {AttentionsComponent}
            </div>
          )}

          {!gridReducerPrimary && ( <>
            {!hideCardNumberDisplays && (
              <div style={{ gridArea: "1/1/2/2" }}>{CardDisplayComponent}</div>
            )}
            <div style={{ gridArea: hideCardNumberDisplays ? "1/1/3/2" : "2/1/3/2", display: "flex" }}>
              {SystemControlsComponent}
            </div>

            <div style={{ gridArea: "1/3/3/4", overflow: "hidden" }}>
              {AttentionsComponent}
            </div>
          </> )}

          <div style={{ gridArea: gridReducerPrimary ? "1/2/4/3" : "1/2/3/3", padding: gridReducerPrimary ? "0px 0px 0px 10px" : "0px 20px", borderLeft: "2px solid " + colors.greyDarkPrimary, borderRight: gridReducerPrimary ? "none" : "2px solid " + colors.greyDarkPrimary, ...css.systemOverviewGrid_container1 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", padding: "0px 5px 150px 0px" }}> {/** */}
              {WidgetComponents}
            </div>
          </div>
        </div>
      </frames._page_inner_content>
    );
  }
});

export default GridLayoutLfOverview